// extracted by mini-css-extract-plugin
module.exports = {"link":"_6lnTT","root":"_2kLdM","label":"wQYUw"};